import { usePracticeAppSelector } from '../redux';
import { useScreenIsMd } from '@orthly/ui-primitives';

export const useShowMobileLayout = (): boolean => {
    const screenIsMedium = useScreenIsMd();
    const isNativeApp = usePracticeAppSelector(s => s.ui.isNativeApp);
    return isNativeApp || screenIsMedium;
};
